import React, { useEffect, useState } from 'react';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

import { TRANSPORTATION_ALL, getPackingTransportation } from './Packing/common';

const DEFAULT_TYPE = 'breakbulk';

/**
 * @param {number} cargoType
 */
function getTransportationTypes(cargoType) {
    const found = getPackingTransportation(cargoType);

    return Object.keys(found);
}

/**
 * 
 * @param {{ 
 *  cargoIndex: number, 
 *  cargoItem: any, 
 *  changeCargo: Function }} value
 */
function Transportation({
    cargoIndex, cargoItem, changeCargo,
}) {
    const [transportation, setTransportation] = useState(DEFAULT_TYPE);
    const [currentTypes, setCurrentTypes] = useState(TRANSPORTATION_ALL);
    
    useEffect(() => {
        const availableTransportation = getTransportationTypes(cargoItem.cargoTypeName);

        const value = cargoItem.typeOfTransportation ||
            availableTransportation[0];
        
        setTransportation(value);
        changeCargo([
            {
                field: `cargo.${cargoIndex}.typeOfTransportation`,
                value,
            },
            {
                field: 'typeOfTransportation',
                value,
            },
        ]);

        setCurrentTypes(availableTransportation);
    }, [
        cargoItem.cargoType,
        cargoItem.typeOfTransportation,
    ]);

    const selectTransportation = (e) => {
        const { value } = e.target;
        setTransportation(value);
        changeCargo([{
            field: `cargo.${cargoIndex}.typeOfTransportation`,
            value,
        }]);
    };

    return (
        <div 
            id='transportation'
            className='row'
            style={{ height: '48px' }}
        >
            <div className='column-left'>
                Category:
            </div>
            <div className='column-right'>
                <RadioButtonGroup 
                    name='transportation_selector' 
                    defaultSelected={transportation}
                    valueSelected={transportation}
                    style={{ display: 'flex', fontSize: '13px' }}
                    onChange={selectTransportation}
                >
                    <RadioButton
                        value='breakbulk'
                        label='Breakbulk'
                        disabled={!currentTypes.includes('breakbulk')}
                    />
                    <RadioButton
                        value='bulk'
                        label='Dry bulk'
                        disabled={!currentTypes.includes('bulk')}
                    />
                    <RadioButton
                        value='wetbulk'
                        label='Wet bulk'
                        disabled={!currentTypes.includes('wetbulk')}
                    />
                    <RadioButton
                        value='container'
                        label='Containerized'
                        disabled={!currentTypes.includes('container')}
                    />
                </RadioButtonGroup>
            </div>
        </div>
    );
}

export default React.memo(Transportation);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Transportation.jsx